<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Add a Service</h4>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v" class="form-wrapper">
                <services-autocomplete
                    ref="servicesRef"
                    label="Service"
                    id="autoservice"
                    placeholder=""
                    v-model="serviceValue"
                    :should-focus="true"
                    :is-required="true"
                />
                <form-group
                    name="description"
                    label="Alternative Description / Notes (Optional)"
                    attribute="Description"
                >
                    <md-input v-model="description" @input="$v.description.$touch()" />
                </form-group>

                <div class="md-layout md-alignment-center-left">
                    <form-group
                        class="md-layout-item md-size-33 quantity"
                        name="quantity"
                        label="Quantity"
                        attribute="Quantity"
                        :messages="localMessages"
                    >
                        <md-input v-model="quantity" type="number" min="0" required @input="$v.quantity.$touch()" />
                    </form-group>
                    <div class="md-layout-item quantity-type">{{ serviceValue.quantityType }}</div>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="md-primary dialog-button" @click="addServiceLine">Save</md-button>
            <md-button class="md-default dialog-button" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required, decimal } from 'vuelidate/lib/validators';
import { handleRequests, showErrorMessage } from '@/helpers';
import { ServicesAutocomplete } from '@/components';

export default {
    name: 'RunScheduleServiceLineModal',
    components: { ServicesAutocomplete },
    mixins: [GeneralMixin],
    props: {
        runScheduleId: { type: Number, default: null },
        lines: { type: Array, default: () => [] },
        resolve: { type: Function, default: () => {} },
        service: { type: Object, default: () => null }
    },
    validations: {
        serviceValue: { required },
        quantity: {
            required,
            decimal,
            minValue: (value) => value > 0,
            maxValue: (value) => value < 10000000
        }
    },
    data() {
        return {
            localMessages: {
                required: '{attribute} is required.',
                decimal: '{attribute} should be a decimal number.',
                minValue: '{attribute} should be a positive number.',
                maxValue: '{attribute} should be less than 10000000'
            },
            quantity: this.service ? this.service.quantity : 0,
            serviceValue: this.service ? this.service : { serviceId: null },
            description: this.service ? this.service.description : ''
        };
    },
    methods: {
        async addServiceLine() {
            this.$v.$touch();
            this.$refs.servicesRef.callTouch();
            const runScheduleId = this.runScheduleId || this.$route.params.runScheduleId;

            if (this.lines.some((s) => s.serviceId === this.serviceValue.serviceId)) {
                showErrorMessage(this, 'This service has already been added. You cannot add it again.');
                return;
            }

            if (!this.$v.$invalid) {
                try {
                    this.$_handleLoaderState(true, 'UPDATING...');
                    const payload = {
                        method: 'post',
                        data: {
                            serviceId: this.serviceValue.serviceId,
                            description: this.description,
                            quantity: Number(this.quantity)
                        }
                    };

                    await handleRequests(`/api/run-schedules/${runScheduleId}/lines`, payload);
                    this.$notify({ message: 'Service added!', type: 'success' });
                    this.$v.$reset();
                    this.resolve(payload.data);
                } catch (e) {
                    showErrorMessage(this, 'Cannot add service.');
                    this.resolve(false);
                } finally {
                    this.$_handleLoaderState(false);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.quantity { padding-left: 0px; }
</style>
